<div>
  <div class="mat-subheading-2" fxLayout fxLayoutGap="4px" fxLayoutAlign="start cetner">
    <mat-icon>queue_music</mat-icon>
    <div>
      <span>TOP TRACK 5</span>
      <span class="date-range">
        {{ criteriaFrom$ | async | date: 'yyyy-MM-dd' }}
        ~
        {{ criteriaTo$ | async | date: 'yyyy-MM-dd' }} までの集計データ
      </span>
      @if (selectedArtist$ | async; as artist) {
        @if (!media.isActive('lt-md')) {
          <a
            href="https://labels.umusic.com/artist/{{ artist.globalId }}"
            target="_blank"
            class="date-range"
            >
            <span>UMLで詳細を見る</span>
            <img src="./assets/outside_link.png" class="icon" />
          </a>
        }
      }
    </div>
    <mat-icon
      class="help"
      matTooltip="上記カレンダーで期間指定された範囲の、曲のストリーム数TOP5（ストリーム（速報値））です。"
      >help_outline</mat-icon
      >
      @if (!(dataCollectLoading$ | async)) {
        @if (
          (dataCollectionsStreams$ | async) && (dataCollectionsDownloads$ | async)) {
          <img
            class="datafix_icon"
            matTooltip="各項目において選択した期間のデータが全部揃っている場合に、チェックマークが表示されます。"
            src="./assets/data_collections.png"
            />
          } @else {
          }
        } @else {
        }
        <app-csv-download
          [id]="csvId"
          [fileName]="csvFileName"
          [csv]="csvData$ | async"
          [loading]="loading$ | async"
          [artist]="selectedArtist$ | async"
        ></app-csv-download>
      </div>
      <div fxLayout="column" fxLayoutGap="8px">
        <app-track-sale
          [trackSales]="trackSales$ | async"
          [loading]="loading$ | async"
        ></app-track-sale>
      </div>
    </div>


